<!-- eslint-disable vue/valid-v-bind -->
<template>
  <div>
    <div>
      <smart-google-places :selected-places.sync="selectedPlaces" />
      <hr v-if="selectors && selectors.length > 0">
      <div class="d-flex align-items-center">
        <b-form-group
          v-for="selector in selectors"
          :key="selector.id"
          :label="selector.title"
          :style="{ marginRight: '20px', width: selector.selectorOptions.width ? selector.selectorOptions.width : '200px' }"
        >
          <v-select
            v-if="selector.options"
            v-model="selector.selected"
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :clearable="selector.selectorOptions.clearable"
            :multiple="selector.selectorOptions.multiple"
            :options="selector.options"
            :reduce="option => option.value"
            style="text-transform: capitalize;"
            @input="(value) => selectorChanged(value, selector.id)"
          />
        </b-form-group>
      </div>
    </div>
    <hr>
    <gmap-map
      :center="center"
      :zoom="zoom"
      :style="{
        width: '100%',
        height: mapHeight + 'px',
      }"
      :options="{
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      }"
    >
      <!-- Add a circle to represent the radius -->
      <gmap-circle
        v-for="(circle, index) in circles"
        :key="index"
        :center="circle.center"
        :radius="circle.radius * 1000"
        :options="circleOptions"
      ></gmap-circle>
  
      <!-- Add markers to the map -->
      <gmap-cluster>
        <gmap-marker
          v-for="(marker, index) in markers"
          :key="index"
          :position="marker"
        ></gmap-marker>
      </gmap-cluster>
    </gmap-map>
  
  </div>
</template>
  
  <script>
import {
    BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import SmartGooglePlaces from '../../smart-components/maps/SmartGooglePlaces.vue'

  export default {
    components: {
        BFormGroup,
        SmartGooglePlaces,
        vSelect,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        mapHeight: {
            type: Number,
            default: 200,
        },
        center: {
            type: Object,
            required: true,
        },
        circles: {
            type: Array,
            required: false,
            default: () => [],
        },
        zoom: {
            type: Number,
            required: true,
        },
        selectors: {
            type: Array,
            default: () => [],
        },
      markers: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        circleOptions: {
          fillColor: "#4285F4",
          fillOpacity: 0.2,
          strokeColor: "#4285F4",
          strokeOpacity: 0.8,
          strokeWeight: 2,
        },
        selectedPlaces: [],
      }
    },
    watch: {
      selectedPlaces() {
        if(this.selectedPlaces.length > 0) {
         const circles = this.selectedPlaces.map(circle => ({
            center: circle.center,
            radius: circle.radius,
          }))
        this.$emit('update:circles', circles)
        }
      },
    },
    methods: {
      selectorChanged(value, id) {
        this.$emit('selectorChanged', value, id)
      },
    },
  }
  </script>
  